import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import IntakeCard from 'candidate/components/IntakeCard'
import { QuestionWrapper } from 'candidate/components/QuestionWrapper'
import { ChoiceBucket } from 'candidate/models/intake'
import { useEffect, useState } from 'react'
import NextButton from 'shared/components/NextButton'

import type { ChangeEvent, Dispatch, FC, SetStateAction } from 'react'

interface Props {
    internalName: string
    answer?: ChoiceBucket
    callback: Dispatch<any>
    choices: ChoiceBucket[]
    prompt: string
    skipCallback?: Dispatch<SetStateAction<string>>
    skipText?: string
}

const MultipleChoiceQuestion: FC<Props> = ({
    internalName,
    answer,
    callback,
    choices,
    prompt,
    skipCallback,
    skipText,
}: Props) => {
    const [disabled, setDisabled] = useState(true)
    const [response, setResponse] = useState({})

    useEffect(() => {
        if (answer) {
            setResponse({ [internalName]: answer[internalName] })
            setDisabled(false)
        }
    }, [answer, internalName])

    return (
        <IntakeCard
            question={prompt}
            skipCallback={skipCallback}
            skipText={skipText}
        >
            <QuestionWrapper>
                <RadioGroup
                    name={'radio-btn-group'}
                    defaultValue={response[internalName]?.choice || ''}
                    value={response[internalName]?.choice || ''}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const selectedChoice = choices.find(
                            (choice) => choice.choice === event.target.value
                        )
                        setResponse({ [internalName]: selectedChoice })
                        setDisabled(false)
                    }}
                >
                    {choices.map((choice, index) => (
                        <FormControlLabel
                            key={index}
                            value={choice.choice}
                            control={<Radio />}
                            label={choice.choice}
                        />
                    ))}
                </RadioGroup>
            </QuestionWrapper>

            <NextButton
                disabled={disabled}
                onClickHandler={() => {
                    setDisabled(true)
                    callback({ response })
                }}
            />
        </IntakeCard>
    )
}

export default MultipleChoiceQuestion
